import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';
import { isLoggedIn as isLoggedInSelector } from 'ggApp/modules/auth/selectors';

import CartSummary from './CartSummary';

const enhance = compose(
    connect(
        createStructuredSelector({
            isLoggedIn: isLoggedInSelector,
        }),
    ),
    withDeviceInfo,
    withProps(({ userDevice }) => ({
        isDesktopUser: userDevice !== 'mobile' && userDevice !== 'tablet',
    })),
);

export default enhance(CartSummary);
